/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable eqeqeq */
import "moment-timezone";
import React, { useContext, useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import wsSend_request from "../../Api/ws/ws_request";
import { WebSocketContext } from "../../App";
import EDIT from "../../assets/image/EDIT.svg";
import { ClearFormSetFutios } from "../../redux/actions/adminAction";
import ReusableTable from "../UserInformation/ReusableTable";

const MachineManagement = () => {
  const { websocket } = useContext(WebSocketContext);
  const { machineList, search, listStatus, ClearFormSet } = useSelector(
    (state) => state.adminReducers
  );
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  const dispatch = useDispatch();

  useEffect(() => {
    callMachineList();
  }, [websocket, currentPage, search, listStatus]);

  const currentFunction = (page) => {
    setCurrentPage(page);
  };

  function callMachineList() {
    let param = {
      transmit: "single",
      url: "machine_list",
      request: {
        status:
          listStatus === undefined || listStatus === ""
            ? ""
            : parseInt(listStatus),
        limit: "20",
        page_no: search ? 1 : currentPage,
        search: search ? search : "",
        order_by: "-updated_at",
      },
    };
    wsSend_request(websocket, param);
  }

  useEffect(() => {
    if (
      ClearFormSet?.url === "machine_status_update" &&
      ClearFormSet?.action === 200
    ) {
      callMachineList();
    } else {
      if (
        ClearFormSet?.url === "machine_status_update" &&
        ClearFormSet?.action === 400
      ) {
        callMachineList();
      }
    }
    setTimeout(() => {
      dispatch(
        ClearFormSetFutios({
          url: "",
          action: "",
        })
      );
    }, 1000);
  }, [ClearFormSet, dispatch]);

  function handleSwitchChange(id, isChecked) {
    let param = {
      transmit: "single",
      url: "machine_status_update",
      request: {
        status: isChecked,
        machine_id: id,
      },
    };
    wsSend_request(websocket, param);
    callMachineList();
  }

  const headers = [
    { name: "Machine Id/Vend Id", key: "machineId" },
    { name: "Machine Name", key: "machine_name" },
    { name: "Acquire Merchant Name", key: "acquire_merchant_name" },
    { name: "Machine Address", key: "machineAddress" },
    { name: "Recipient Name", key: "recipient_name" },
    { name: "Type", key: "type" },
    { name: "Payment Acquire API", key: "payment_acquire_api" },
    { name: "Status", key: "status1" },
    { name: "Action", key: "status2" },
  ];

  const renderRow = (machine, index, visibleColumns) => {
    return (
      <React.Fragment key={machine?.id}>
        <tr key={machine.id} className="user-management-table-detail">
          {visibleColumns?.includes("machineId") && (
            <td style={{ cursor: "default" }} className="Vertical_align">
              {machine.machine_code ? machine.machine_code : "-"}
            </td>
          )}
          {visibleColumns?.includes("machine_name") && (
            <td style={{ cursor: "default" }} className="Vertical_align">
              {machine.machine_name
                ? `${machine.machine_name} (ID :${machine.machine_code})`
                : "-"}
            </td>
          )}
          {visibleColumns?.includes("acquire_merchant_name") && (
            <td style={{ cursor: "default" }} className="Vertical_align">
              {machine.acquirer_merchant_name
                ? machine.acquirer_merchant_name
                : "-"}
            </td>
          )}
          {visibleColumns?.includes("machineAddress") && (
            <td style={{ cursor: "default" }} className="Vertical_align">
              {machine.machine_address ? machine.machine_address : "-"}
            </td>
          )}
          {visibleColumns?.includes("recipient_name") && (
            <td style={{ cursor: "default" }} className="Vertical_align">
              {machine.recipient_name ? machine.recipient_name : "-"}
            </td>
          )}
          {visibleColumns?.includes("type") && (
            <td style={{ cursor: "default" }} className="Vertical_align">
              {machine?.machine_type
                ? machine?.machine_type
                    .split("_")
                    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(" ")
                : "-"}
            </td>
          )}
          {visibleColumns?.includes("payment_acquire_api") && (
            <td style={{ cursor: "default" }} className="Vertical_align">
              {(() => {
                const map = {
                  arvgo_mybalance: "ARVgo Mybalance",
                  fiuu: "Fiuu",
                  ntt_online: "NTT Online",
                  ntt_offline: "NTT Offline",
                };

                const active = Object.keys(map)
                  .filter((key) => machine[key])
                  .map((key) => map[key]);

                return active.length > 0 ? active.join(", ") : "-";
              })()}
            </td>
          )}

          {visibleColumns?.includes("status1") && (
            <td style={{ cursor: "pointer" }}>
              <span>
                <Form.Check
                  type="switch"
                  id="custom-switch"
                  defaultChecked={machine.is_active}
                  onChange={(e) =>
                    handleSwitchChange(machine.id, e.target.checked)
                  }
                />
              </span>
            </td>
          )}
          {visibleColumns?.includes("status2") && (
            <td>
              <span
                className="detail-icon"
                onClick={() =>
                  navigate("/edit-machine/" + machine?.machine_code)
                }
              >
                <img src={EDIT} alt="edit" title="Edit" />
              </span>
            </td>
          )}
        </tr>
      </React.Fragment>
    );
  };

  return (
    <>
      <ReusableTable
        headers={headers}
        data={machineList?.list}
        paginationObject={machineList?.pagination}
        renderRow={renderRow}
        filters={{
          fromDate: false,
          toDate: false,
          period: false,
          search: true,
          searchPlaceholder: "Search by Machine Id/Vend Id, Machine Address",
          isAdd: true,
          isAddtitle: "Add Machine",
          isAddLink: "/add-machine",
          userSelect: false,
          userOptions: [],
          export: true,
        }}
        currentPage={currentPage}
        handlePageChange={currentFunction}
      />
    </>
  );
};

export default MachineManagement;
